import languages from '../img/blog/languages.webp'
import dynamicHold from '../img/blog/dynamic-hold.webp'
import launch5 from '../img/blog/launch-5.webp'
import launch6 from '../img/blog/launch-6.webp'
import launch3 from '../img/blog/launch-3.webp'
import launchInline1 from '../img/blog/launch-inline-1.webp'
import launchInline2 from '../img/blog/launch-inline-2.webp'
import { getPosts } from './content/index.js'
import { DEFAULT_LANG } from '../lib/locale'

const IMAGES = {
    'multiple-languages': { image: languages },
    'micro-breaks': {},
    'dynamic-hold-system': { bodyImages: [dynamicHold] },
    'science-of-sitting': { image: launch5 },
    'benefits-of-moving': { image: launch6, bodyImages: [launchInline2] },
    'keybreak-launch': { bodyImages: [launchInline1, launch3] },
}

// Bodies are globbed so a new translation only needs the file: `<slug>.md` is
// English, `<slug>.<lang>.md` is that language.
const modules = import.meta.glob('./posts/*.md', { eager: true })

const BODIES = {}

for (const [path, module] of Object.entries(modules)) {
    const [, slug, lang = DEFAULT_LANG] = /\.\/posts\/([a-z0-9-]+?)(?:\.([a-z]{2}))?\.md$/.exec(path)
    BODIES[slug] = { ...BODIES[slug], [lang]: module.html }
}

const withBody = (post, lang) => ({
    ...post,
    ...IMAGES[post.slug],
    html: BODIES[post.slug][lang] || BODIES[post.slug][DEFAULT_LANG],
})

export const getAllPosts = (lang) => getPosts(lang).map((post) => withBody(post, lang))

export const getPublishedPosts = (lang) => getAllPosts(lang).filter((p) => !p.draft)

export const getPostBySlug = (lang, slug) => getAllPosts(lang).find((p) => p.slug === slug)

export const getLatestPost = (lang) => getPublishedPosts(lang)[0]
